import { Attr, BelongsTo, Model } from "spraypaint";

import { ApplicationRecord } from "shared/services/spraypaint";

import type PodcastEpisode from "./PodcastEpisode";

@Model()
class PodcastEpisodeFragment extends ApplicationRecord {
  static jsonapiType = "podcast_episode_fragments";

  @Attr({ persist: false }) createdAt: string;

  @Attr() endTimeMs: number;

  @BelongsTo() podcastEpisode: PodcastEpisode;

  @Attr() podcastEpisodeId: number;

  @Attr() speaker: string;

  @Attr() startTimeMs: number;

  @Attr() text: string;

  @Attr({ persist: false }) updatedAt: string;
}

export default PodcastEpisodeFragment;
